import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import _ from "lodash";
import { API_END_POINT } from "../config";

const token = Cookie.get("waffle_world_access_token");
import { JWT_SECRET_TOKEN } from "../config";
import Cookie from "js-cookie";
const jwt = require("jsonwebtoken");
import Select from "react-select";
import "react-select/dist/react-select.css";

export default class LocationsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      item: {
        name: "",
        adress: "",
        status: "",
      },
    };
    // this.rteState = RichTextEditor.createEmptyValue();
    // API_END_POINT = 'https://admin.saaditrips.com';
    this.handleInputChange = this.handleInputChange.bind(this);
    this.postItem = this.postItem.bind(this);
  }

  componentWillMount() {
    axios.get(`${API_END_POINT}/api/categories`).then((response) => {
      this.setState({
        categories: response.data.objects,
      });
    });
    axios
      .get(`${API_END_POINT}/api/brands`, { headers: { "auth-token": token } })
      .then((response) => {
        this.setState({
          brands: response.data.objects,
        });
      });
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.itemId) {
      this.getLocationbyId();
    }
  }

  getLocationbyId = () => {
    const { match } = this.props;
    axios
      .get(`${API_END_POINT}/api/locations/one`, {
        params: { locationId: match.params.itemId },
        headers: { "auth-token": token },
      })
      .then((response) => {
        this.setState(
          {
            item: response.data.object[0],
            brand: { name: response.data.object[0].brandName },
          },
          () => {
            axios
              .get(`${API_END_POINT}/api/categories/one`, {
                params: { categoryId: this.state.item.categoryId },
                headers: { "auth-token": token },
              })
              .then((response) => {
                this.setState({
                  category: response.data.object[0],
                });
              });
            // axios
            //   .get(`${API_END_POINT}/api/brands/one`, {
            //     params: { brandId: this.state.item.brandId },
            //     headers: { "auth-token": token },
            //   })
            //   .then((response) => {
            //     this.setState({
            //       brand: response.data.object[0],
            //     });
            //   });
          }
        );
        delete this.state.item.image;
      });
  };

  fetchUsers() {
    axios.get(`${API_END_POINT}/api/user/fetch`).then((response) => {
      this.setState({
        users: response.data,
      });
    });
  }

  fetchHotels() {
    axios.get(`${API_END_POINT}/api/hotel/fetch`).then((response) => {
      this.setState({
        hotels: response.data,
      });
    });
  }

  fetchPackages() {
    axios
      .get(`${API_END_POINT}/api/fetch/packagePage-fetch`)
      .then((response) => {
        this.setState({
          packages: response.data,
        });
      });
  }

  fetchExperiences() {
    axios
      .get(`${API_END_POINT}/api/fetch/experience-fetch`)
      .then((response) => {
        this.setState({
          experiences: response.data,
        });
      });
  }

  setHotel = (selectedHotel) => {
    this.setState((prevState) => ({
      hotel: selectedHotel,
      item: {
        ...prevState.item,
        hotel_id: selectedHotel.ID,
      },
    }));
  };

  setPackage = (selectedPackage) => {
    this.setState((prevState) => ({
      pckg: selectedPackage,
      item: {
        ...prevState.item,
        package_id: selectedPackage.ID,
      },
    }));
  };

  setUser = (selectedUser) => {
    this.setState((prevState) => ({
      user: selectedUser,
      item: {
        ...prevState.item,
        user_id: selectedUser.ID,
        user_name: `${selectedUser.first_name} ${selectedUser.last_name}`,
      },
    }));
  };

  setExperience = (selectedExperience) => {
    this.setState((prevState) => ({
      experience: selectedExperience,
      item: {
        ...prevState.item,
        expereience_id: selectedExperience.ID,
      },
    }));
  };

  setDescription(description) {
    const { item } = this.state;
    item.comment = description.toString("html");
    this.setState({
      item,
      description,
    });
  }

  setCategory(selectedCategory) {
    this.setState((prevState) => ({
      category: selectedCategory,
      item: {
        ...prevState.item,
        categoryId: selectedCategory._id,
      },
    }));
  }

  setBrand(selectedBrand) {
    this.setState((prevState) => ({
      brand: selectedBrand,
      item: {
        ...prevState.item,
        brandName: selectedBrand.name,
      },
    }));
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { item } = this.state;
    item[name] = value;
    this.setState({ item });
  }

  handleImages = (event) => {
    const { name } = event.target;
    const { item } = this.state;
    item[name] = event.target.files[0];
    this.setState({ item });
  };

  postItem(event) {
    event.preventDefault();
    const { match, history, location } = this.props;
    const { loading, item } = this.state;

    const fd = new FormData();
    Object.keys(item).forEach((eachState) => {
      fd.append(`${eachState}`, item[eachState]);
    });
    fd.append("status", "any status");

    if (!loading) {
      this.setState({ loading: true });
      delete item["isSpecialOffer"];
      delete item["specialOfferPrice"];

      if (match.params.itemId) {
        let itemCopy = { ...item };

        itemCopy.locationId = itemCopy._id;
        delete itemCopy["_id"];
        delete itemCopy["date"];
        delete itemCopy["__v"];
        delete itemCopy["isActive"];
        this.setState({ item: itemCopy });
        const fd = new FormData();
        Object.keys(itemCopy).forEach((eachState) => {
          fd.append(`${eachState}`, itemCopy[eachState]);
        });
        const token = jwt.sign({ payload: item }, JWT_SECRET_TOKEN, {
          expiresIn: "1h",
        });
        axios
          .post(`${API_END_POINT}/api/locations/update`, fd, {
            headers: { "auth-token": token },
          })
          .then((response) => {
            //console.log("<<<---", token);
            if (response.data && response.status === 200) {
              window.alert(response.data.message);
              this.setState({ loading: false });
              this.props.history.goBack();
            } else {
              window.alert("ERROR");
              this.setState({ loading: false });
            }
          });
      } else {
        const tokenx = jwt.sign({ payload: item }, JWT_SECRET_TOKEN, {
          expiresIn: "1h",
        });

        axios
          .post(`${API_END_POINT}/api/locations`, fd, {
            headers: { "auth-token": tokenx },
          })
          .then((response) => {
            if (response.data && response.status === 200) {
              window.alert(response.data.msg);
              this.setState({ loading: false });
              this.props.history.goBack();
            } else {
              window.alert("ERROR", response.data.error);
              this.setState({ loading: false });
            }
          })
          .catch((error) => {
            this.setState({ loading: false });
            window.alert("ERROR", error);
          });
      }
    }
  }

  render() {
    const { loading, item, category, categories, brand, brands } = this.state;
    const { location } = this.props;
    // const selectedFormName = _.startCase(location.state.selectedRating);
    console.log(this.state);

    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Abholort details eingeben:</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postItem}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Name
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name"
                          className="form-control"
                          value={item.name}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Adresse
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="adress"
                          className="form-control"
                          value={item.adress}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />
                          Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/LocationsForms.jsx